import { faPencilAlt, faPlusCircle, faTrashAlt, faRedo, faKey, faArrowUp, faArrowDown, faFolderOpen, faInfoCircle, faNetworkWired, faFileDownload, faClipboardCheck, faFileCode, faHistory, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

export const plusIcon = faPlusCircle;
export const editIcon = faPencilAlt;
export const trashIcon = faTrashAlt;
export const redoIcon = faRedo;
export const keyIcon = faKey;
export const arrowUp = faArrowUp;
export const arrowDown = faArrowDown;
export const openIcon = faFolderOpen;
export const infoIcon = faInfoCircle;
export const ftpLogIcon = faNetworkWired;
export const responseFileIcon = faFileDownload;
export const validationIcon = faClipboardCheck;
export const xmlEditIcon = faFileCode;
export const historyIcon = faHistory;
export const warningIcon = faExclamationTriangle;
